import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const Navbar = () => {
  const [activeMenu, setActiveMenu] = useState('/');

  const handleMenuClick = (path) => {
    setActiveMenu(path);
  };

  return (
    <NavContainer>
      <NavItem>
        <StyledLink 
          to="/" 
          isActive={activeMenu === '/'}
          onClick={() => handleMenuClick('/')}
        >
          Accueil
        </StyledLink>
      </NavItem>
      <NavItem>
        <StyledLink 
          to="/about" 
          isActive={activeMenu === '/about'}
          onClick={() => handleMenuClick('/about')}
        >
          À propos
        </StyledLink>
      </NavItem>
      <NavItem>
        <StyledLink 
          to="/principal" 
          isActive={activeMenu === '/principal'}
          onClick={() => handleMenuClick('/principal')}
        >
          Principes
        </StyledLink>
      </NavItem>
      <NavItem>
        <StyledLink 
          to="/contact" 
          isActive={activeMenu === '/contact'}
          onClick={() => handleMenuClick('/contact')}
        >
          Contact
        </StyledLink>
      </NavItem>
    </NavContainer>
  );
};

export default Navbar;

// Styles avec styled-components
const NavContainer = styled.nav`
  display: flex;
  justify-content: center;
  background-color: #2c3e50;
  padding: 10px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    padding: 5px;
  }
`;

const NavItem = styled.div`
  margin: 0 15px;

  @media (max-width: 768px) {
    margin: 5px 10px; /* Réduit l'espacement entre les liens */
  }
`;

const StyledLink = styled(NavLink)`
  text-decoration: none;
  font-size: 1.2rem;
  color: ${(props) => (props.isActive ? '#3498db' : '#ecf0f1')};
  border-bottom: ${(props) => (props.isActive ? '2px solid #3498db' : 'none')};
  padding: 5px;

  &:hover {
    color: #3498db;
  }

  @media (max-width: 768px) {
    font-size: 1rem; /* Réduit la taille du texte sur les petits écrans */
  }

  @media (max-width: 480px) {
    font-size: 1rem; /* Encore plus petit sur les très petits écrans */
  }
`;
